import React from 'react';
import PropTypes from 'prop-types';
import { Button, List } from 'semantic-ui-react';

import Image from '../../atoms/Image';
// logo assets
import oneFish from './fisherman-one-fish.png';
import twoFish from './fisherman-two-fish.png';
import textLogo from './fisherman-text.png';

// static vars
const sizeMap = {
  tiny: 1,
  small: 2,
  medium: 3,
  large: 4,
  huge: 5,
  massive: 6,
};
const assetMap = {
  oneFishLogo: oneFish,
  twoFishLogo: twoFish,
  textLogo,
  poweredBy: textLogo,
};
const baseSize = 20;

export default class FishermanIcon extends React.PureComponent {
  getContainer(asset) {
    const { as, size } = this.props;

    if (as === 'link') {
      return <a href="https://fishrmn.com">{asset}</a>;
    }

    if (as === 'button') {
      return (
        <Button size={size} secondary>
          {asset}
        </Button>
      );
    }

    if (as === 'image') return asset;
    return asset;
  }

  getWrappedAsset() {
    const { assetType } = this.props;
    const assetImage = assetMap[assetType];

    if (assetType === 'poweredBy') {
      return (
        <List horizontal>
          <List.Item>
            <div style={{ color: 'white' }}>Powered By</div>
          </List.Item>
          <List.Item>
            <Image
              src={assetMap.poweredBy}
              height="25"
              style={{ marginTop: '-5px', marginLeft: '-8px' }}
            />
          </List.Item>
        </List>
      );
    }

    return <Image src={assetImage} height={this.calculateSize()} />;
  }

  calculateSize() {
    const { size } = this.props;

    return baseSize * sizeMap[size];
  }

  render() {
    const assetWrapped = this.getWrappedAsset();
    return this.getContainer(assetWrapped);
  }
}

FishermanIcon.propTypes = {
  assetType: PropTypes.oneOf(['oneFishLogo', 'twoFishLogo', 'textLogo', 'poweredBy']),
  as: PropTypes.oneOf(['link', 'button', 'image']),
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large', 'huge', 'massive']),
};

FishermanIcon.defaultProps = {
  assetType: 'twoFishLogo',
  as: 'image',
  size: 'small',
};
